<template>
    <div style="position: relative">
        <Spin v-if="pageLoading" fix size="large"></Spin>
        <Row class="row">
            <Col span="4">
            <label class="title-label">标签分类名称</label>
            </Col>
            <Col span="4" offset="1">
            <label class="title-label">操作</label>
            </Col>
        </Row>
        <div v-for="(tag,index) in list">
            <Form :ref="'tag'+index" :model="list[index]" :rules="rule">
                <Row>
                    <Col span="4">
                        <FormItem prop="tagname">
                            <Input v-model="tag.tagname" placeholder="请填写分类名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="4" offset="1">
                        <Button type="default" style="background-color: #fff;" @click="deleteOne(index)" class="btn-del">删除</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <Row>
            <Col span="4">
                <button class="add-one-btn" @click="addOne"><i class="fa fa-plus"></i>添加标签分类</button>
            </Col>
        </Row>

        <div class="save-btn">
            <Button type="primary" style="width: 150px" @click="saveTagType" :loading="loadingStatus">保存</Button>
        </div>

        <warning ref="delwarn" :title="warningMsg.title" @callback="deleteType">
            <div  slot="body"><p>{{warningMsg.tip}}</p></div>
        </warning>
    </div>
</template>

<script>
    import Warning from "@/components/warningModal/Warning.vue";
    import tagTypeValidate from "@/validateRule/company/tagType";
    import utils from "@/utils";
    import $api from "@/service";

    export default {
        components: {Warning},
        props : {
            Warning
        },
        data(){
            return {
                loadingStatus : false,
                list : [],
                rule : tagTypeValidate,
                warningMsg : {
                    delindex : "",
                    title : "删除确认",
                    tip : "",
                },
                pageLoading : true,
            }
        },
        created(){
            this.getList();
        },
        methods : {
            //获取分类
            getList(){
                let _self = this;
                this.pageLoading = true;
                $api.getTagType().then(data=>{
                    _self.pageLoading = false;
                    _self.list = data;
                });
            },
            //删除一项
            deleteOne(index){
                if(this.list[index].id === ""){
                    this.list.splice(index,1);
                }else{
                    this.warningMsg.delindex = index;
                    this.warningMsg.tip = "是否删除 "+ this.list[index].tagname + " 分类？";
                    this.$refs.delwarn.show();
                }
            },
            //删除提示框回调
            deleteType(){
                //执行删除
                let _self = this;
                this.$refs.delwarn.doLoading();
                $api.deleteTagType(this.list[this.warningMsg.delindex].id).then(data=>{
                    _self.$refs.delwarn.noLoading();
                    _self.$refs.delwarn.hide();
                    if(data.code === "200"){
                        _self.list.splice(_self.warningMsg.delindex,1);
                        _self.warningMsg.delindex = "";
                        utils.notice("删除成功","success");
                    }else{
                        utils.notice(data.msg,"error");
                    }
                });
            },
            //添加一项
            addOne(){
                this.list.push({
                    "id"        :   "",
                    "tagname"   :   "",
                })
            },
            //保存按钮
            saveTagType(){
                let res = true;
                if(this.list.length<=0){
                    utils.notice("请添加标签分类","error");
                    return false;
                }
                for(let i = 0 ; i < this.list.length; i++){
                    this.$refs["tag"+i][0].validate((valid) => {
                        if (!valid) {
                            res = false;
                        }
                    })
                }
                if(!res){
                    utils.notice("请填写标签分类","error");
                    return false;
                }
                this.loadingStatus = true;
                let _self = this;
                $api.saveTagType(this.list).then(data=>{
                    if(data.code === "200"){
                        _self.loadingStatus = false;
                        utils.message({title:"保存成功"},"success");
                        _self.getList();
                    }else{
                        utils.message({title:data.msg},"error");
                    }

                });
            }
        },
    }
</script>

<style scoped>
@import "./type.less";
</style>


// WEBPACK FOOTER //
// src/pages/company/tag/Type.vue